import { render, staticRenderFns } from "./pushmessages.vue?vue&type=template&id=5684c0b8&scoped=true&"
import script from "./pushmessages.vue?vue&type=script&lang=js&"
export * from "./pushmessages.vue?vue&type=script&lang=js&"
import style0 from "./pushmessages.vue?vue&type=style&index=0&id=5684c0b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684c0b8",
  null
  
)

export default component.exports